module.exports = __webpack_public_path__ + "static/media/placeholderImg.b54da161.svg";